// @ts-nocheck
import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import {BotonVerde} from "../../Difusiones/Componentes/BotonVerde";

const useStyles = makeStyles((theme) => ({
    button: {
        margin: "8px"
    },
}));

export const ConfirmationButton = (props) => {
    const {children, onClose, ...others} = props;
    const classes = useStyles();

    return (
        <BotonVerde
            className={classes.button}
            variant="contained"
            autoFocus
            onClick={onClose}
            {...others}
        >
            {children}
        </BotonVerde>
    );
};